import { render, staticRenderFns } from "./FollowRecord.vue?vue&type=template&id=0a18bf37&"
import script from "./FollowRecord.vue?vue&type=script&lang=js&"
export * from "./FollowRecord.vue?vue&type=script&lang=js&"
import style0 from "./FollowRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FollowRecord.vue"
export default component.exports